module.exports = __webpack_public_path__ + "img/orange.91456e55.png";